import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import React from 'react';

let SievePortionPreparationSectionDryingAfterSeparation: React.FC<IWorksheetComponent> = () => (
  <>
    <NamePrefixModifier appendNamePrefix="MassMeasurement">
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
        <Field input={<NumericInput />} name="TareMass" />
        <Field input={<NumericInput />} name="TareAndWetMass" />
        <Field input={<TextOutput />} name="WetMass" />
      </ListFieldSection>
    </NamePrefixModifier>
    <ListFieldSection heading="Sieve Portion Dry Mass">
      <Field input={<TextOutput />} name="DryMass" />
    </ListFieldSection>
  </>
);

SievePortionPreparationSectionDryingAfterSeparation = withInjectedProps(
  SievePortionPreparationSectionDryingAfterSeparation
);

export { SievePortionPreparationSectionDryingAfterSeparation };
export default SievePortionPreparationSectionDryingAfterSeparation;
